import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { AiOutlineApi } from "react-icons/ai";
import { MdOutlineCancel, MdOutlineShowChart } from "react-icons/md";
import { RiMoneyDollarBoxLine } from "react-icons/ri";
import {
  TbAddressBook,
  TbArrowsExchange,
  TbList,
  TbListDetails,
  TbReportMoney,
  TbSignature,
  TbUsersGroup,
} from "react-icons/tb";
import { Link, NavLink } from "react-router-dom";

import {
  FaFileSignature,
  FaFileWord,
  FaMapLocation,
  FaMapLocationDot,
  FaUsersRectangle,
} from "react-icons/fa6";
import { useStateContext } from "../contexts/ContextProvider";

const Sidebar = () => {
  const links = [
    {
      title: "Recap",
      links: [
        {
          name: "Platform Signatures Recap",
          icon: <TbList />,
        },
      ],
    },
    {
      title: "Main",
      links: [
        {
          name: "Document Signatures",
          icon: <TbListDetails />,
        },
      ],
    },
    {
      title: "User",
      links: [
        {
          name: "User List",
          icon: <TbUsersGroup />,
        },
        {
          name: "Balance Transaction",
          icon: <TbReportMoney />,
        },
        {
          name: "Audit Trail",
          icon: <MdOutlineShowChart />,
        },
        {
          name: "Integrated Platform",
          icon: <AiOutlineApi />,
        },
        {
          name: "Recap Pascabayar",
          icon: <TbReportMoney />,
        },
        {
          name: "Pascabayar Payment",
          icon: <TbReportMoney />,
        },
        {
          name: "Pascabayar Transaction",
          icon: <TbReportMoney />,
        },
        {
          name: "Topup Transaction Log",
          icon: <TbAddressBook />,
        },
      ],
    },
    {
      title: "Markany",
      links: [
        {
          name: "Membership Types",
          icon: <FaUsersRectangle />,
        },
        {
          name: "Document Types",
          icon: <FaFileWord />,
        },
        {
          name: "Signature Specimen",
          icon: <TbSignature />,
        },
        {
          name: "Document Verify",
          icon: <FaFileSignature />,
        },
      ],
    },
    {
      title: "Masterdata",
      links: [
        {
          name: "Transaction Config",
          icon: <TbArrowsExchange />,
        },
        {
          name: "Payment Methods",
          icon: <RiMoneyDollarBoxLine />,
        },
        {
          name: "Transaction Report Summary",
          icon: <RiMoneyDollarBoxLine />,
        },
        {
          name: "Province",
          icon: <FaMapLocation />,
        },
        {
          name: "City",
          icon: <FaMapLocationDot />,
        },
      ],
    },
  ];

  const { currentColor, activeMenu, setActiveMenu, screenSize } =
    useStateContext();

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const activeLink =
    "flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-white text-md m-2";
  const normalLink =
    "flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-2";

  return (
    <div className="ml-3 pr-3 h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10">
      {activeMenu && (
        <>
          <div className="flex justify-center items-center">
            <Link
              to="/"
              onClick={handleCloseSideBar}
              className="items-center gap-3 ml-3 mt-4 flex text-xl font-extrabold tracking-tight dark:text-white text-slate-900"
            >
              <span>Dashboard</span>
            </Link>
            <TooltipComponent content="Menu" position="BottomCenter">
              <button
                type="button"
                onClick={() => setActiveMenu(!activeMenu)}
                style={{ color: currentColor }}
                className="text-xl rounded-full p-3 hover:bg-light-gray mt-4 block md:hidden"
              >
                <MdOutlineCancel />
              </button>
            </TooltipComponent>
          </div>
          <div className="mt-10 ">
            {links.map((item) => (
              <div key={item.title}>
                <p className="text-gray-400 dark:text-gray-400 m-3 mt-4 uppercase">
                  {item.title}
                </p>
                {item.links.map((link) => (
                  <NavLink
                    to={`/${item.title
                      .toLowerCase()
                      .replaceAll(" ", "-")}/${link.name
                      .toLowerCase()
                      .replaceAll(" ", "-")}`}
                    key={link.name}
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    {link.icon}
                    <span className="capitalize ">{link.name}</span>
                  </NavLink>
                ))}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;
